import { formatDate } from "../../components/DateUtil";
import { useNavigate } from "react-router-dom";

export default function MagicEOMList({ data}) {
    let navigate = useNavigate()

    function handleMagicEOMDetailList(order) {
        // month not plus 1 because have to create new Date()
        const orderDate = new Date(order.request_dt)
        const _orderdate = orderDate.getFullYear() + '-' + orderDate.getMonth() + '-' + orderDate.getDate()
        let params = 'orderdate=' + _orderdate + '&type=' + order.transtype

        navigate('/report/magiceomdetail?' + params)
    }

    return (
        <>
            <div id="orderPaymentList" className="table-responsive table-hover table-sales text-nowrap">
                <table id="basic-datatables" className="table table-striped table-hover align-items-center mb-0">
                    <thead className="thead-light">
                        <tr>
                            <th scope="col">Order Date</th>
                            <th scope="col" className="text-end">No. from Magic</th>
                            <th scope="col" className="text-end">No. from EOM</th>
                            <th scope="col">Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data?.map((order, index) => {
                                let transType = ''
                                if (order.transtype === 'S') transType = 'No order generated'
                                else if (order.transtype === 'O') transType = 'More than 1 order generated'
                                else if (order.transtype === 'M') transType = 'Normal'
                                else if (order.transtype === 'N') transType = 'Abnormal'

                                return (
                                    <tr key={index}>
                                        <td>{formatDate(new Date(order.request_dt))}</td>
                                        <td className="text-end">{new Intl.NumberFormat().format(order.magic_records)}</td>
                                        <td className="text-end">{new Intl.NumberFormat().format(order.eom_records)}</td>
                                        <td>
                                            <button type="button" title="Magic EOM Detail" className="btn btn-link link-secondary link-offset-2 link-underline link-underline-opacity-0" onClick={handleMagicEOMDetailList.bind(this, order)}>
                                                <i className="bi bi-layers"></i>
                                            </button>
                                            {transType}
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>

        </>
    )
}
